exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._1iljp{position:relative;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;margin-bottom:20px}._1iljp,._250Dn{display:-webkit-box;display:-ms-flexbox;display:flex}._250Dn{-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;-webkit-box-align:center;-ms-flex-align:center;align-items:center;padding:10px 0}._2WPWo h1{font-size:20px;font-weight:700}._1SyMc{position:relative;background:transparent;font-size:20px;height:30px;cursor:pointer;width:40px;text-align:center;outline:none;font-weight:400;margin:0 0 0 -1px;border:0;border-bottom:2px solid transparent}._1SyMc img{opacity:.5}._1SyMc:first-of-type{margin:0}._1SyMc:disabled{cursor:auto;border-bottom:3px solid #ffd906}._1SyMc:disabled img{opacity:1}._1SyMc:focus img,._1SyMc:hover img{z-index:1;opacity:1}._3BInd{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;padding:5px 0;background:#f5f5f5}._1o4gT{margin:10px 15px 10px 0;-webkit-box-flex:0;-ms-flex-positive:0;flex-grow:0;-ms-flex-negative:0;flex-shrink:0;-ms-flex-preferred-size:calc(33.33333% - 10px);flex-basis:calc(33.33333% - 10px)}._1o4gT:nth-of-type(3n){margin-right:0}._3Zfhz{margin-bottom:10px}._3Zfhz,.h7LQs{background:#fff;width:100%}.h7LQs{padding:20px 0;text-align:center}", ""]);

// exports
exports.locals = {
	"root": "_1iljp",
	"header": "_250Dn",
	"title": "_2WPWo",
	"headerButton": "_1SyMc",
	"table": "_3BInd",
	"tableItem": "_1o4gT",
	"ads": "_3Zfhz",
	"emptyBlock": "h7LQs"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./node_modules/postcss-loader/lib?{"config":{"path":"./tools/postcss.config.js"}}!./src/desktop/routes/journal/components/NewsList/NewsList.css
// module id = 2795
// module chunks = 16 32